var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tw-flex tw-flex-row tw-items-center",attrs:{"id":_vm.id + '__fb_datePicker__'}},[_c('article',{class:[
      'tw-w-11 tw-h-full',
      'tw-inline-block',
      'tw-relative',
      'tw-bg-gray-500',
      {
        'tw-cursor-pointer  hover:tw-bg-primary': !_vm.disabled,
        'tw-bg-opacity-50': _vm.disabled,
      },
    ],on:{"click":function($event){return _vm.handleClick($event)}}},[_c('DatePicker',{key:_vm.timestamp,ref:"datePicker",attrs:{"use-utc":"","disabled":_vm.disabled,"value":_vm.modelValue,"append-to-body":false,"fixed-position":'bottom-right'},on:{"input":_vm.toggleChange,"closed":_vm.toggleClose}}),_c('span',{staticClass:"tw-absolute tw-right-0 tw-top-0 tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full"},[_c('CalendarIcon',{staticClass:"tw-text-white",attrs:{"size":"1.5x"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }